import React from 'react';
import { Link } from 'react-router-dom';
import { Send } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface DesktopNavProps {
  onSendRequest: () => void;
}

const DesktopNav: React.FC<DesktopNavProps> = ({
  onSendRequest
}) => {
  const { t } = useTranslation();

  return <nav className="hidden md:flex mx-0 px-0">
      <button onClick={onSendRequest} className="text-gray-800 hover:text-[#00d09e] transition-colors mx-[20px] bg-transparent border-none cursor-pointer">
        <span className="flex items-center gap-1">
          <Send size={18} />
          <span className="font-semibold text-[#00d09e]">{t('desktopNav.sendRequest')}</span>
        </span>
      </button>
      <Link to="/search" className="text-gray-800 hover:text-[#00d09e] transition-colors mx-[23px]">
        {t('desktopNav.searchProfessionals')}
      </Link>
      <Link to="/articles" className="text-gray-800 hover:text-[#00d09e] transition-colors mx-[23px]">
        {t('desktopNav.tipsAndArticles')}
      </Link>
      <Link to="/contact" className="text-gray-800 hover:text-[#00d09e] transition-colors mx-[23px]">
        {t('desktopNav.contact')}
      </Link>
      <Link to="/about" className="text-gray-800 hover:text-[#00d09e] transition-colors mx-[23px] px-[8px]">
        {t('desktopNav.about')}
      </Link>
    </nav>;
};

export default DesktopNav;